import { throwIf } from '../throwErrorF/throwIfF.mts';
export function assertTruthy(value, debugCtx) {
    throwIf(() => !value, debugCtx);
}
